import React, { useState } from 'react';
import toSnakeCase from '../../../../helpers/to_snake_case';

function ExpandedElement({ expandedText, expandalbeId }) {
  return (
    <p
      id={expandalbeId}
      className="product-selector__selling-point-expanded-content"
    >
      {expandedText}
    </p>
  );
}

function ExpandableSellingPoint({
  expandableText,
  subText,
  expandedText,
  onClickCallback,
}) {
  const [showExpandedElement, updateShowExpandedElement] = useState(false);
  const expandalbeId = toSnakeCase(expandableText);
  return (
    <div>
      <button
        aria-expanded={showExpandedElement ? 'true' : 'false'}
        aria-controls={expandalbeId}
        type="button"
        className="button button--link product-selector__selling-point-expand"
        onClick={() => {
          updateShowExpandedElement(!showExpandedElement);
          if (onClickCallback) {
            onClickCallback();
          }
        }}
      >
        {expandableText}
      </button>
      {` ${subText}`}
      {showExpandedElement ? (
        <ExpandedElement
          expandedText={expandedText}
          expandalbeId={expandalbeId}
        />
      ) : null}
    </div>
  );
}

export default ExpandableSellingPoint;
